import { Component, Input } from '@angular/core';
import { IconName } from '@app/shared/utils/icon/icons';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../utils/icon/icon.component';
import { TranslatePipe } from '@app/shared/pipes';

@Component({
  selector: 'app-qr-code-display',
  templateUrl: './qr-code-display.component.html',
  styleUrls: ['./qr-code-display.component.scss'],
  imports: [NgClass, IconComponent, TranslatePipe],
})
export class QrCodeDisplayComponent {
  @Input() qrCodeLink: string;
  @Input() fullWidth = false;
  @Input() instructions: string;
  public readonly IconName = IconName;
}
